import React, { useState } from "react";
import { pageTitle } from "../PageTitle";
import HeaderOne from "../Header/HeaderOne";
import FooterOne from "../Footer/FooterOne";
import { Link, useLocation } from "react-router-dom";
import service from "../../assets/images/banner/data-analytics.png";
import basebg from "../../assets/images/resource/base.png";
import g1 from "../../assets/images/resource/da.png";
import videoSource from "../../assets/videos/vdo-1.mp4";

const Data_Analytics = () => {
  pageTitle("Data & Analytics");

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    phone: "",
    message: "",
  });

  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    setFormData({ name: "", email: "", subject: "", phone: "", message: "" });
  };

  const servicesData = [
    { id: 1, title: "AI WhatsApp Agents", slug: "/Whatsapp-estore" },
    { id: 2, title: "RPA", slug: "/RPA-AI" },
    { id: 3, title: "Data & Analytics", slug: "/Data-Analytics" },
    // { id: 4, title: "Web Development", slug: "/Web-Development" },
    // { id: 5, title: "Digital Consulting", slug: "/digital-consultancy" },
  ];
  const dataAnalyticsMenu = [
    { label: "DATA ADMINISTRATOR", path: "/Data-Administrator" },
    { label: "DATA ENGINEERING", path: "/Data-Engineering" },
    { label: "AI & ML", path: "/ai-ml" },
  ];
  const renderServices = () =>
    servicesData.map((service) => (
      <li
        key={service.id}
        className={service.slug === "/content-marketing" ? "active" : ""}
      >
        <Link to={service.slug}>{service.title}</Link>
      </li>
    ));
  const getYouTubeVideoId = (url) => {
    const regExp =
      /(?:youtube\.com\/(?:shorts\/|watch\?v=)|youtu\.be\/)([^&?/]+)/;
    const match = url.match(regExp);
    return match ? match[1] : null;
  };

  const featuredYoutubeLink =
    "https://youtu.be/Spw2va7f6m8?si=xBEYfUesNKdanuG4";

  const featuredVideoId = getYouTubeVideoId(featuredYoutubeLink);

  const featuredEmbedUrl = `https://www.youtube.com/embed/${featuredVideoId}`;

  return (
    <>
      <HeaderOne />

      <section className="page__title p_relative">
        <div
          className="bg-layer"
          style={{
            backgroundImage: `url(${g1})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        ></div>
        <div className="auto-container">
          <div className="content__box p_relative"></div>
        </div>
      </section>

      {/* <div className="service__details p_relative">
        <div className="auto-container">
          <div className="row service__details__row d-flex flex-wrap"> */}
            {/* Right Paragraph */}
            {/* Right Image */}
            {/* <div className="col-xl-8 col-lg-12 col-md-12 service__right p-pad">
              <figure>
                <img src={service} alt="" className="service-images" />
              </figure>
            </div> */}

            {/* Left Sidebar */}
            {/* <div className="col-xl-4 col-lg-6 col-md-12 service__details__left">
              <div
                className="sidebar__widget_network"
                style={{ backgroundImage: `url(${basebg})` }}
              >
                <h3 style={{ paddingBottom: "20px" }}>Data & Analytics</h3>
                <iframe
                  width="100%"
                  height="550"
                  src={featuredEmbedUrl}
                  title="Featured YouTube Short"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div> */}

            {/* Full Width Paragraph */}
            <div className="container service__full__content">
              <h2>Data & Analytics</h2>

              <p>
                Focused on unlocking new revenue opportunities, enhancing
                customer experiences, and optimizing operational efficiency.
              </p>

              <p>
                In today’s rapidly evolving digital economy, vast amounts of
                valuable insights remain hidden within the data we generate
                every day.
              </p>

              <p>
                <span className="SiW">SiW</span> helps you uncover these
                insights and build a robust analytics ecosystem that delivers
                sustainable competitive advantage.
              </p>

              <p>
                Despite this potential, many organizations still struggle to
                establish truly effective analytics capabilities, as success
                demands the right blend of people, processes, and technology.
              </p>

              <p>
                <span className="SiW">SiW</span>’s enterprise data and analytics
                services guide you with a balanced strategy—starting small,
                moving quickly, and delivering measurable results early.
              </p>
            </div>

            {/*Data analytics divisions */}
            <div className="col-12  IA da-services">
              <section className="siw-data-analytics-section ">
                <div className="container">
                <h1 className="siw-data-analytics-title">
                SiW's Data & Analytics Services
                </h1>

                <div className="siw-data-analytics-layout">
                  {/* LEFT NAVIGATION */}
                  <nav className="siw-data-analytics-nav">
                    {dataAnalyticsMenu.map((item, index) => (
                      <Link
                        key={index}
                        to={item.path}
                        className="siw-data-analytics-nav-item"
                      >
                        <span className="siw-data-analytics-nav-text">
                          {item.label}
                        </span>
                        <span className="siw-data-analytics-nav-arrow">›</span>
                      </Link>
                    ))}
                  </nav>

                  {/* RIGHT CONTENT CARD */}
                  <aside className="siw-data-analytics-aside">
                    <img
                      src="static/media/cloudera-partner-badge.bea6d1f0f7f1dfc2b1c8.jpg"
                      alt="cloudera"
                    />

                    {/* <p className="siw-data-analytics-aside-item">
                  Azure Cloud Modernization
                </p>
                <p className="siw-data-analytics-aside-item">
                  Power BI Solutions
                </p> */}

                    <div className="siw-data-analytics-partner">
                      <strong className="siw-data-analytics-partner-name">
                        Cloudera
                      </strong>
                      <span className="siw-data-analytics-partner-role">
                        Solutions Partner
                      </span>
                      <small className="siw-data-analytics-partner-scope">
                        Data & AI
                      </small>
                    </div>
                  </aside>
                  </div>
                  </div>
              </section>
            </div>
          {/* </div>
        </div>
      </div> */}
      <FooterOne />

      {/* Responsive Ordering CSS */}
      <style>{`
        @media (max-width: 991px) {
          .service__details__row {
            display: flex;
            flex-direction: column;
          }
          .service__right { order: 1; }
          .IA { order: 2; margin: 20px 0; }
          .service__details__left { order: 3; }
        }

        @media (min-width: 992px) {
          .service__details__row {
            flex-direction: row;
          }
          .service__right, .IA, .service__details__left {
            order: initial;
            margin: 0;
          }
            .service__details__left{
            height:50vh;
            }
        }
      `}</style>
    </>
  );
};

export default Data_Analytics;
